/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Paper,
  CircularProgress
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import AccountCircle from '@material-ui/icons/AccountCircle';
import { Input } from '../../components';
import * as authActions from '../../store/auth/actions';
import { hideLoader } from '../../store/loader/actions';
import NewPasswordForm from './forms/NewPasswordForm';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
    length: { maximum: 64 }
  },
  password: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
    length: { maximum: 128 }
  }
};

const useStyles = makeStyles(theme => ({
  grid: {
    height: '100%',
    backgroundImage: 'url(/images/homeNew.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  paper: {
    padding: theme.spacing(10, 12),
    minHeight: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 3),
    },
  },
  form: {
    width: 350,
    maxWidth: '100%',
  },
  title: {
    marginTop: theme.spacing(3)
  },
  input: {
    marginTop: theme.spacing(2)
  },
  loginIcon: {
    paddingRight: 11,
    paddingLeft: 11
  },
  icon: {
    color: theme.palette.text.secondary
  },
  logo: {
    width: 275,
    maxWidth: '100%',
  },
  logoContainer: {
    paddingLeft: theme.spacing(4)
  },
  parceiroContainer: {
    paddingTop: theme.spacing(7)
  },
  parceiroLogo: {
    width: 130
  },
  parceiroTitle: {
    fontSize: 18,
    paddingBottom: 10
  }
}));

const Login = ({ login, hideLoader }) => {
  const classes = useStyles();
  let history = useHistory();

  const [viewPassword, setViewPassword] = useState(false);
  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    hideLoader()
  }, [hideLoader]);

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const callback = shouldUpdatePassword => {
    if (shouldUpdatePassword) {
      setShowPasswordForm(true);
    } else {
      history.push('/nsirs');
    }
  }

  const handleLogin = () => {
    setLoading(true);
    login(formState.values, (shouldUpdatePassword, successLogin) => {
      setLoading(false);
      if (successLogin) {
        callback(shouldUpdatePassword);
      }
    });
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <Grid className={classes.grid} container>
      <Grid container spacing={0} direction="column" alignItems="flex-end" justify="start">
        {showPasswordForm ? <NewPasswordForm /> : <Paper className={classes.paper} elevation={3}>
          <Grid item className={classes.logoContainer}> 
            <img src="/images/logos/logo.png" alt='logo' className={classes.logo}/>
          </Grid>
          <Grid item className={classes.form} component="form" onSubmit={(e) => { e.preventDefault(); if (formState.isValid) handleLogin(); }}>
            <Typography className={classes.title} variant="h3">
              Login
            </Typography>
            <Input
              error={hasError('email')}
              classNameInputGroup={classes.input}
              helperText={hasError('email') ? formState.errors.email[0] : null}
              label="Usuário"
              name="email"
              onChange={handleChange}
              isRequired
              value={formState.values.email || ''}
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" className={classes.loginIcon}>
                    <AccountCircle className={classes.icon}/>
                  </InputAdornment>
                ),
              }}
            />
            <Input
              error={hasError('password')}
              classNameInputGroup={classes.input}
              helperText={hasError('password') ? formState.errors.password[0] : null}
              label="Senha"
              name="password"
              onChange={handleChange}
              isRequired
              value={formState.values.password || ''}
              type={viewPassword ? 'text' : 'password'}
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setViewPassword(!viewPassword)}>
                      {viewPassword ? <Visibility className={classes.icon}/> : <VisibilityOff className={classes.icon}/>}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              className={classes.input}
              color="primary"
              disabled={!formState.isValid || loading}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
            </Button>
          </Grid>
          <Grid item className={classes.parceiroContainer}> 
            <Typography className={classes.parceiroTitle} variant="h3">
              Parceiros:
            </Typography>
            <img src="/images/cemig.png" alt='Cemig' className={classes.parceiroLogo}/>
          </Grid>
        </Paper>}
      </Grid>
    </Grid>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  hideLoader: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => bindActionCreators({
  ...authActions,
  hideLoader
}, dispatch);

export default connect(null, mapDispatchToProps)(Login);
